// Generated by scripts/sync-bindings.ts (bindings.config.ts joined with specs/openapi.json). Do not edit.

/** One endpoint a component fetches for itself: the `data-endpoint` value, its method, and the config attributes that select it on a component that renders several. */
export interface SelfFetchEndpoint {
  endpoint: string;
  method: 'GET' | 'POST';
  attrs?: Record<string, string>;
}

export const almanacDayEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "chinese-astrology/calendar/day/{date}",
    "method": "GET",
    "attrs": {
      "mode": "day"
    }
  },
  {
    "endpoint": "chinese-astrology/calendar/monthly",
    "method": "GET",
    "attrs": {
      "mode": "month"
    }
  },
  {
    "endpoint": "chinese-astrology/calendar/auspicious-days",
    "method": "POST",
    "attrs": {
      "mode": "auspicious"
    }
  }
];

export const angelNumberCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "angel-numbers/numbers/{number}",
    "method": "GET"
  },
  {
    "endpoint": "angel-numbers/daily",
    "method": "POST"
  }
];

export const angelNumberLookupEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "angel-numbers/lookup",
    "method": "GET"
  }
];

export const arudhaPadasEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/arudha",
    "method": "POST"
  }
];

export const ashtakavargaGridEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/ashtakavarga",
    "method": "POST"
  }
];

export const aspectsTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/aspects",
    "method": "POST"
  },
  {
    "endpoint": "astrology/transit-aspects",
    "method": "POST"
  },
  {
    "endpoint": "astrology/aspect-patterns",
    "method": "POST"
  }
];

export const astrocartographyMapEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/astrocartography",
    "method": "POST"
  }
];

export const baziChartEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "chinese-astrology/bazi/chart",
    "method": "POST"
  }
];

export const bhavChalitTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/bhav-chalit",
    "method": "POST"
  }
];

export const bhavaBalaTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/bhava-bala",
    "method": "POST"
  }
];

export const biorhythmChartEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "biorhythm/daily",
    "method": "POST",
    "attrs": {
      "mode": "daily"
    }
  },
  {
    "endpoint": "biorhythm/forecast",
    "method": "POST",
    "attrs": {
      "mode": "forecast"
    }
  },
  {
    "endpoint": "biorhythm/critical-days",
    "method": "POST",
    "attrs": {
      "mode": "critical-days"
    }
  }
];

export const bodygraphEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "human-design/bodygraph",
    "method": "POST"
  }
];

export const charaKarakasEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/chara-karakas",
    "method": "POST"
  }
];

export const choghadiyaGridEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/panchang/choghadiya",
    "method": "POST"
  }
];

export const compatibilityCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/compatibility-score",
    "method": "POST",
    "attrs": {
      "mode": "astrology"
    }
  },
  {
    "endpoint": "numerology/compatibility",
    "method": "POST",
    "attrs": {
      "mode": "numerology"
    }
  },
  {
    "endpoint": "biorhythm/compatibility",
    "method": "POST",
    "attrs": {
      "mode": "biorhythm"
    }
  }
];

export const compoundNumberEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "numerology/compound-number/{number}",
    "method": "GET"
  }
];

export const crystalCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "crystals/{id}",
    "method": "GET"
  }
];

export const crystalGridEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "crystals",
    "method": "GET"
  },
  {
    "endpoint": "crystals/chakra/{chakra}",
    "method": "GET"
  },
  {
    "endpoint": "crystals/element/{element}",
    "method": "GET"
  },
  {
    "endpoint": "crystals/zodiac/{sign}",
    "method": "GET"
  },
  {
    "endpoint": "crystals/birthstone/{month}",
    "method": "GET"
  },
  {
    "endpoint": "crystals/search",
    "method": "GET"
  }
];

export const dashaTimelineEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/dasha/major",
    "method": "POST",
    "attrs": {
      "period": "major"
    }
  },
  {
    "endpoint": "vedic-astrology/dasha/current",
    "method": "POST",
    "attrs": {
      "period": "current"
    }
  },
  {
    "endpoint": "vedic-astrology/dasha/sub/{mahadasha}",
    "method": "POST",
    "attrs": {
      "period": "sub"
    }
  },
  {
    "endpoint": "vedic-astrology/dasha/sub/{mahadasha}/{antardasha}",
    "method": "POST",
    "attrs": {
      "period": "antara"
    }
  },
  {
    "endpoint": "vedic-astrology/dasha/sub/{mahadasha}/{antardasha}/{pratyantardasha}",
    "method": "POST",
    "attrs": {
      "period": "sookshma"
    }
  },
  {
    "endpoint": "vedic-astrology/dasha/sub/{mahadasha}/{antardasha}/{pratyantardasha}/{sookshma}",
    "method": "POST",
    "attrs": {
      "period": "prana"
    }
  }
];

export const divisionalChartEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/divisional-chart",
    "method": "POST"
  },
  {
    "endpoint": "vedic-astrology/navamsa",
    "method": "POST"
  }
];

export const doshaCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/dosha/manglik",
    "method": "POST",
    "attrs": {
      "type": "manglik"
    }
  },
  {
    "endpoint": "vedic-astrology/dosha/kalsarpa",
    "method": "POST",
    "attrs": {
      "type": "kalsarpa"
    }
  },
  {
    "endpoint": "vedic-astrology/dosha/sadhesati",
    "method": "POST",
    "attrs": {
      "type": "sadhesati"
    }
  }
];

export const doshaConstitutionEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "ayurveda/constitution",
    "method": "POST"
  }
];

export const dreamCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "dreams/symbols/{id}",
    "method": "GET"
  }
];

export const dreamSearchEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "dreams/symbols",
    "method": "GET"
  }
];

export const ephemerisTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/planets/monthly",
    "method": "POST"
  },
  {
    "endpoint": "vedic-astrology/planetary-positions/monthly",
    "method": "POST"
  }
];

export const fixedStarsEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/fixed-stars",
    "method": "POST"
  }
];

export const flyingStarChartEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "feng-shui/flying-stars/natal",
    "method": "POST",
    "attrs": {
      "mode": "natal"
    }
  },
  {
    "endpoint": "feng-shui/flying-stars/annual/{year}",
    "method": "GET",
    "attrs": {
      "mode": "annual"
    }
  }
];

export const forecastDigestEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "forecast/digest",
    "method": "POST"
  }
];

export const forecastTimelineEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "forecast/timeline",
    "method": "POST"
  },
  {
    "endpoint": "forecast/significant-dates",
    "method": "POST"
  },
  {
    "endpoint": "forecast/transits",
    "method": "POST"
  }
];

export const gematriaEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "kabbalah/gematria",
    "method": "POST"
  }
];

export const gocharaTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/transit",
    "method": "POST"
  }
];

export const gunaMilanEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/compatibility",
    "method": "POST"
  }
];

export const hdConnectionEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "human-design/connection",
    "method": "POST"
  }
];

export const hdPentaEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "human-design/penta",
    "method": "POST"
  }
];

export const hdTypeCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "human-design/type",
    "method": "POST"
  },
  {
    "endpoint": "human-design/profile",
    "method": "POST"
  }
];

export const hdVariablesEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "human-design/variables",
    "method": "POST"
  }
];

export const heliacalTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/heliacal",
    "method": "POST"
  }
];

export const hexagramEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "iching/hexagrams/random",
    "method": "GET"
  },
  {
    "endpoint": "iching/hexagrams/{number}",
    "method": "GET"
  },
  {
    "endpoint": "iching/hexagrams/lookup",
    "method": "GET"
  },
  {
    "endpoint": "iching/cast",
    "method": "GET"
  },
  {
    "endpoint": "iching/daily",
    "method": "POST"
  },
  {
    "endpoint": "iching/daily/cast",
    "method": "POST"
  }
];

export const horaTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/panchang/hora",
    "method": "POST"
  }
];

export const horoscopeCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/horoscope/{sign}/daily",
    "method": "GET",
    "attrs": {
      "period": "daily"
    }
  },
  {
    "endpoint": "astrology/horoscope/{sign}/weekly",
    "method": "GET",
    "attrs": {
      "period": "weekly"
    }
  },
  {
    "endpoint": "astrology/horoscope/{sign}/monthly",
    "method": "GET",
    "attrs": {
      "period": "monthly"
    }
  },
  {
    "endpoint": "astrology/horoscope/{sign}/yearly",
    "method": "GET",
    "attrs": {
      "period": "yearly"
    }
  }
];

export const kpChartEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/kp/chart",
    "method": "POST"
  }
];

export const kpFinanceCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/kp/daily-finance",
    "method": "POST"
  }
];

export const kpPlanetsTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/kp/planets",
    "method": "POST"
  }
];

export const kpRulingPlanetsEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/kp/ruling-planets",
    "method": "POST"
  }
];

export const kuaCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "feng-shui/kua",
    "method": "POST",
    "attrs": {
      "mode": "kua"
    }
  },
  {
    "endpoint": "feng-shui/eight-mansions",
    "method": "POST",
    "attrs": {
      "mode": "mansions"
    }
  }
];

export const localSpaceCompassEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/local-space",
    "method": "POST"
  }
];

export const luckPillarsEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "chinese-astrology/bazi/luck-pillars",
    "method": "POST"
  }
];

export const mayanDaySignEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "mesoamerican-astrology/mayan/tzolkin",
    "method": "POST",
    "attrs": {
      "mode": "day"
    }
  },
  {
    "endpoint": "mesoamerican-astrology/mayan/chart",
    "method": "POST",
    "attrs": {
      "mode": "chart"
    }
  }
];

export const moonPhaseEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/moon-phase/current",
    "method": "GET",
    "attrs": {
      "mode": "current"
    }
  },
  {
    "endpoint": "astrology/moon-phase/upcoming",
    "method": "GET",
    "attrs": {
      "mode": "upcoming"
    }
  },
  {
    "endpoint": "astrology/moon-phase/calendar/{year}/{month}",
    "method": "GET",
    "attrs": {
      "mode": "calendar"
    }
  }
];

export const nakshatraCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/nakshatras/{id}",
    "method": "GET"
  }
];

export const natalChartEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/natal-chart",
    "method": "POST"
  }
];

export const numerologyCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "numerology/life-path",
    "method": "POST",
    "attrs": {
      "type": "life-path"
    }
  },
  {
    "endpoint": "numerology/expression",
    "method": "POST",
    "attrs": {
      "type": "expression"
    }
  },
  {
    "endpoint": "numerology/soul-urge",
    "method": "POST",
    "attrs": {
      "type": "soul-urge"
    }
  },
  {
    "endpoint": "numerology/personality",
    "method": "POST",
    "attrs": {
      "type": "personality"
    }
  },
  {
    "endpoint": "numerology/birth-day",
    "method": "POST",
    "attrs": {
      "type": "birth-day"
    }
  },
  {
    "endpoint": "numerology/maturity",
    "method": "POST",
    "attrs": {
      "type": "maturity"
    }
  },
  {
    "endpoint": "numerology/daily",
    "method": "POST",
    "attrs": {
      "type": "daily"
    }
  },
  {
    "endpoint": "numerology/personal-day",
    "method": "POST",
    "attrs": {
      "type": "personal-day"
    }
  },
  {
    "endpoint": "numerology/personal-month",
    "method": "POST",
    "attrs": {
      "type": "personal-month"
    }
  },
  {
    "endpoint": "numerology/personal-year",
    "method": "POST",
    "attrs": {
      "type": "personal-year"
    }
  },
  {
    "endpoint": "numerology/chart",
    "method": "POST",
    "attrs": {
      "type": "chart"
    }
  }
];

export const panchangTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/panchang/detailed",
    "method": "POST",
    "attrs": {
      "detail": "detailed"
    }
  },
  {
    "endpoint": "vedic-astrology/panchang/basic",
    "method": "POST",
    "attrs": {
      "detail": "basic"
    }
  }
];

export const positionsTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/asteroids",
    "method": "POST"
  },
  {
    "endpoint": "astrology/lilith",
    "method": "POST"
  },
  {
    "endpoint": "astrology/progressions",
    "method": "POST"
  },
  {
    "endpoint": "astrology/solar-arc",
    "method": "POST"
  },
  {
    "endpoint": "astrology/arabic-lots",
    "method": "POST"
  }
];

export const profectionCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/profections",
    "method": "POST"
  }
];

export const referenceCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/signs/{id}",
    "method": "GET"
  },
  {
    "endpoint": "astrology/planet-meanings/{id}",
    "method": "GET"
  },
  {
    "endpoint": "vedic-astrology/rashis/{id}",
    "method": "GET"
  },
  {
    "endpoint": "iching/trigrams/{id}",
    "method": "GET"
  },
  {
    "endpoint": "human-design/gates/{number}",
    "method": "GET"
  },
  {
    "endpoint": "human-design/centers/{id}",
    "method": "GET"
  },
  {
    "endpoint": "numerology/meanings/{number}",
    "method": "GET"
  },
  {
    "endpoint": "vedic-astrology/avasthas/{id}",
    "method": "GET"
  }
];

export const relocationWheelEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/relocation-chart",
    "method": "POST"
  }
];

export const shadbalaTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/shadbala",
    "method": "POST"
  }
];

export const synastryChartEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/synastry",
    "method": "POST"
  }
];

export const tarotCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "tarot/daily",
    "method": "POST"
  },
  {
    "endpoint": "tarot/cards/{id}",
    "method": "GET"
  }
];

export const tarotCatalogEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "tarot/cards",
    "method": "GET"
  }
];

export const tarotSpreadEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "tarot/spreads/three-card",
    "method": "POST",
    "attrs": {
      "spread": "three-card"
    }
  },
  {
    "endpoint": "tarot/spreads/celtic-cross",
    "method": "POST",
    "attrs": {
      "spread": "celtic-cross"
    }
  },
  {
    "endpoint": "tarot/spreads/love",
    "method": "POST",
    "attrs": {
      "spread": "love"
    }
  },
  {
    "endpoint": "tarot/spreads/career",
    "method": "POST",
    "attrs": {
      "spread": "career"
    }
  },
  {
    "endpoint": "tarot/spreads/custom",
    "method": "POST",
    "attrs": {
      "spread": "custom"
    }
  },
  {
    "endpoint": "tarot/yes-no",
    "method": "POST",
    "attrs": {
      "spread": "yes-no"
    }
  },
  {
    "endpoint": "tarot/draw",
    "method": "POST",
    "attrs": {
      "spread": "draw"
    }
  }
];

export const transitWheelEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/transit-aspects",
    "method": "POST"
  }
];

export const transitsTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/transits",
    "method": "POST"
  }
];

export const upagrahaTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/upagraha",
    "method": "POST"
  }
];

export const vastuMandalaEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vastu/mandala",
    "method": "POST",
    "attrs": {
      "mode": "mandala"
    }
  },
  {
    "endpoint": "vastu/entrance",
    "method": "POST",
    "attrs": {
      "mode": "entrance"
    }
  }
];

export const vedicAspectsEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/aspects",
    "method": "POST"
  }
];

export const vedicDailyEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/daily",
    "method": "POST"
  }
];

export const vedicKundliEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/birth-chart",
    "method": "POST"
  }
];

export const vedicPlanetsTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/birth-chart",
    "method": "POST"
  }
];

export const westernPlanetsTableEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "astrology/natal-chart",
    "method": "POST"
  }
];

export const yogaListEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "vedic-astrology/yoga",
    "method": "GET"
  },
  {
    "endpoint": "vedic-astrology/yoga/detect",
    "method": "POST"
  },
  {
    "endpoint": "vedic-astrology/yoga/{id}",
    "method": "GET"
  }
];

export const zodiacCardEndpoints: readonly SelfFetchEndpoint[] = [
  {
    "endpoint": "chinese-astrology/zodiac/sign",
    "method": "POST",
    "attrs": {
      "mode": "sign"
    }
  },
  {
    "endpoint": "chinese-astrology/zodiac/animals/{id}",
    "method": "GET",
    "attrs": {
      "mode": "animal"
    }
  },
  {
    "endpoint": "chinese-astrology/zodiac/{id}/daily",
    "method": "GET",
    "attrs": {
      "mode": "daily"
    }
  },
  {
    "endpoint": "chinese-astrology/zodiac/compatibility/{sign1}/{sign2}",
    "method": "GET",
    "attrs": {
      "mode": "compatibility"
    }
  }
];
